import { Amplify } from 'aws-amplify';
import { config } from '../config/Config';

export const configureAmplify = () =>
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito.USER_POOL_ID,
        userPoolClientId: config.cognito.APP_CLIENT_ID,
        identityPoolId: config.cognito.IDENTITY_POOL_ID,
      },
    },
    Storage: {
      S3: {
        bucket: config.s3.BUCKET,
        region: config.cognito.REGION,
      },
    },
  });
